
import { isImageUrl, truncateForTooltip } from "@/lib/mapper/cell-display";
import { InlineArrow } from "@/components/icons/InlineArrow";

type Props = {
  value: string;
  onViewFull: () => void;
};

export function CellHoverCard({ value, onViewFull }: Props) {
  const img = isImageUrl(value);
  const { text, truncated } = truncateForTooltip(value, 500);

  return (
    <div className="pointer-events-auto absolute left-0 top-full z-40 mt-1 w-[360px] rounded-md border border-slate-200 bg-white p-2 text-[12px] shadow-lg dark:border-border dark:bg-surface">
      {img ? (
        <div className="space-y-1">
          <img
            src={value}
            alt="preview"
            className="max-h-40 w-full rounded bg-slate-50 object-contain dark:bg-surface-2"
            loading="lazy"
          />
          <div className="truncate text-slate-500" title={value}>
            {value}
          </div>
        </div>
      ) : (
        <div className="space-y-1">
          <div className="max-h-40 overflow-hidden whitespace-pre-wrap break-words text-slate-700 dark:text-slate-300">
            {text || "Blank"}
          </div>
          {truncated && (
            <button
              type="button"
              onClick={(event) => {
                event.stopPropagation();
                onViewFull();
              }}
              className="text-sky-600 hover:underline dark:text-sky-400"
            >
              View full <InlineArrow />
            </button>
          )}
        </div>
      )}
    </div>
  );
}
